import { render, staticRenderFns } from "./ResumeInfo.vue?vue&type=template&id=6628b3db&"
import script from "./ResumeInfo.vue?vue&type=script&lang=js&"
export * from "./ResumeInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports